import React from 'react';
import If from 'components/if-statement';
import { Container, Count, Icon } from './style';
import { useNotificationSideDrawerOperations } from 'components/canvas/hooks/use-notification-side-drawer-visibility';
import { useQuery } from '@apollo/client';
import { notificationsQuery } from 'graphql/user/queries/notifications';
import { userNotificationCreatedSubscription } from 'graphql/user/subscriptions/user-notification-created';
import { useLoggedUser } from 'state/user';

function NotificationIcon(props) {
  const { setVisibility } = useNotificationSideDrawerOperations();

  const [user] = useLoggedUser();

  const { data, subscribeToMore } = useQuery(notificationsQuery, {
    variables: { input: { filter: { status: 'unseen' } } },
    //pollInterval: 15000,
    fetchPolicy: 'cache-and-network',
  });

  React.useEffect(() => {
    if (user?.id) {
      subscribeToMore({
        document: userNotificationCreatedSubscription,
        variables: { user: user?.id },
        updateQuery: (previousQueryResult, { subscriptionData }) => {
          const newNotification =
            subscriptionData.data?.userNotificationCreated;

          if (newNotification) {
            // not empty
          }

          return previousQueryResult;
        },
      });
    }
  }, [subscribeToMore, user?.id]);

  const notSeenCount = data?.notifications?.meta?.totalCount ?? 0;

  function showNotificationSideDrawer() {
    setVisibility(true);
  }

  return (
    <Container onClick={showNotificationSideDrawer} {...props}>
      <Icon />
      <If condition={notSeenCount}>
        <Count>{notSeenCount}</Count>
      </If>
    </Container>
  );
}

export default NotificationIcon;
